var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{attrs:{"bottom":true},scopedSlots:_vm._u([{key:"tooltipActivator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({},on),[_vm._v(" "+_vm._s(_vm.mainChamp)+" ")])]}},{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('stats.lol.player-characteristics.main-champ', 1, {name: _vm.summonerName, champ: _vm.mainChamp}))+" ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }